import {
    type InitApiDeclaration,
    initClientApi,
} from '@routellers/services/dist/api/init-client-api';
import axios, { type AxiosInstance, type InternalAxiosRequestConfig } from 'axios';

let unauthorizedHandler: (() => void) | null = null;

export const setUnauthorizedHandler = (handler: (() => void) | null) => {
    unauthorizedHandler = handler;
};

/** Nest query DTOs expect nested objects (e.g. `where`) as JSON strings. */
const serializeParams = (params: Record<string, unknown>): string => {
    const search = new URLSearchParams();

    for (const [key, value] of Object.entries(params)) {
        if (value === undefined) continue;
        search.set(key, typeof value === 'object' ? JSON.stringify(value) : String(value));
    }

    return search.toString();
};

const createHttp = (): AxiosInstance => {
    const http = axios.create();

    http.interceptors.request.use((config: InternalAxiosRequestConfig) => {
        if (config.params && typeof config.params === 'object') {
            config.paramsSerializer = {
                serialize: (params) => serializeParams(params as Record<string, unknown>),
            };
        }

        return config;
    });

    return http;
};

export const api: InitApiDeclaration = initClientApi(process.env.REACT_APP_API_DOMAIN || '', {
    axiosInstance: createHttp(),
    withCredentials: true,
    onUnauthorized: () => {
        unauthorizedHandler?.();
    },
});

export const apiErrorMessage = (error: unknown): string => {
    const err = error as { response?: { data?: { message?: string } }; message?: string };

    return err?.response?.data?.message || err?.message || 'Something went wrong. Please try again.';
};
